
export { default as T } from "./T.js"
export { default as allPass } from "./allPass.js"
export { default as compose } from "./compose.js"
export { default as cond } from "./cond.js"
export { default as curry } from "./curry.js"
export { default as ifElse } from "./ifElse.js"
export { default as includes } from "./includes.js"
export { default as last } from "./last.js"
export { default as omit } from "./omit.js"
export { default as pick } from "./pick.js"
export { default as prop } from "./prop.js"
export { default as propEq } from "./propEq.js"
export { default as propSatisfies } from "./propSatisfies.js"
export { default as when } from "./when.js"